import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "App/store/hooks";
import { refreshToken } from "App/store/slices/user.slice";
import Loader from "App/utils/Loader";

/**
 * Restores the session on a cold load. AppNavigator will not render any route
 * until this settles, so a logged-in user never flashes the login screen.
 */
const RefreshToken: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.user.loading);
  const refreshTokenLoaded = useAppSelector((state) => state.user.refreshTokenLoaded);

  useEffect(() => {
    const token = localStorage.getItem("refreshToken");
    dispatch(refreshToken({ token }));
  }, [dispatch]);

  return <>{loading && !refreshTokenLoaded && <Loader message="Loading..." size={30} />}</>;
};

export default RefreshToken;
